import { booleanAttribute, Component, computed, input } from '@angular/core';
import { SscIconComponent } from '../ssc-icon/ssc-icon.component';
import { ActiveDirective } from '../../../directives';

export enum SscMenuItemHierarchy {
  normal = 'normal',
  danger = 'danger',
}

@Component({
  selector: 'button[ssc-menu-item], a[ssc-menu-item]',
  templateUrl: 'menu-item.component.html',

  host: {
    '[class]': 'classes()',
  },
  imports: [SscIconComponent],
  styleUrls: ['menu-item.component.scss'],
  hostDirectives: [ActiveDirective],
})
export class SscMenuItemComponent {
  svg = input<string>();
  iconOnly = input(false);
  tall = input(false, { transform: booleanAttribute });
  hierarchy = input<SscMenuItemHierarchy>(SscMenuItemHierarchy.normal);
  classes = computed(() => {
    const text =
      this.hierarchy() === SscMenuItemHierarchy.danger
        ? 'text-text-danger dark:text-text-dangerDark bg-background-danger/5 dark:bg-background-dangerDark/5 '
        : 'dark:text-text-faint text-text-dark';
    return `w-full flex items-center gap-4 hover-layer px-4 rounded-3xl ${text} truncate overflow-hidden text-lg font-medium ${
      this.tall() ? 'h-16' : 'h-14'
    }`;
  });
}
